var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};
OCS.WxBriefing.Classes.AlertContainer = new Class({
    Implements: [Options, Events],
    options: {
        activation_button_id: "update_btn",
        button_text: "ADVISORIES",
        container_id: "alert_container"

    },
    element: null,
    mode: "normal",
    initialize: function (element, ops) {
        if (!element) {
            element = document.id(this.options.container_id);
        }
        if (!element) {
            element = new Element('div', {id: this.options.container_id});
            element.inject(document.body);
        }
        this.element = element;
        var current_obj = element.retrieve('alert_container');
        if (current_obj) {
            if (ops) {
                current_obj.setOptions(ops);
            }
            return current_obj;
        }
        var btn = document.id(this.options.activation_button_id);
        if (btn) {
            btn.addEvent('click', this.on_button_click.bind(this));
        }
        this.setOptions(ops);
        this.element.store('alert_container', this);
    },
    draw: function (alerts) {
        var tm = OCS.WxBriefing.Functions.get_template_manager();
        var output = tm.get_html('alert_window', {alerts: alerts});
        this.element.getChildren().destroy();
        Elements.from(output).inject(this.element);
        this.element.getElements('div.advisory_info').each(function (el) {
            new OCS.Classes.WarningPopup(el);
        });
        this.element.getElements('.alert_close').addEvent('click', this.on_close_click.bind(this));
        var btn = document.id(this.options.activation_button_id);
        if (btn) {
            if (alerts.length) {
                btn.set('html', this.options.button_text + ' <img src="/images/okfirst/weather_briefing/flat/alert.png" /><sup>' + alerts.length + '</sup>');
            } else {
                btn.set('html', this.options.button_text);
            }
        }
    },
    close: function () {
        this.element.removeClass('active');
    },
    open: function () {
        this.element.addClass('active');
    },
    toggle: function () {
        if (this.element.hasClass('active')) {
            this.close();
        } else {
            this.open();
        }
    },

    on_button_click: function (event) {
        event.stop();
        this.toggle();
    },
    on_close_click: function (event) {
        event.stop();
        this.close();
    },
    get_advisory_text_popup: function () {
        if (!this.advisory_text_popup) {
            // Initialize the popup
            this.advisory_text_popup = new OCS.Classes.WarningPopup(jQuery(document.body), {openOnEvent: 'click', target: jQuery('#panel_container')});
        }
        return this.advisory_text_popup;
    },
    set_mode: function (in_mode) {
        var old_mode = this.mode;
        this.mode = in_mode;
        var btn = document.id(this.options.activation_button_id);
        if (btn) {
            btn.removeClass(old_mode).addClass(this.mode);
        }

    },
    destroy: function () {
        if (this.element) {
            this.element.removeEvents();
            this.element.store('alert_container', null);
            this.element.destroy();
            this.element = null;
        }
        this.removeEvents();
    }

});

